// extracted by mini-css-extract-plugin
module.exports = {"multi-select":"subfracc_multi-select__2ahPh","multi-label":"subfracc_multi-label__1ac3J","multi-box":"subfracc_multi-box__1czdW","multi-option":"subfracc_multi-option__2lAba"};